import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type SendEmailPayload = {
  leadId?: string;
  applicantId?: string;
  to: string[];
  cc?: string[];
  subject: string;
  message: string;
};

export type SendEmailResult = {
  logId: string;
  providerMessageId?: string;
  status: string;
};

@Injectable({ providedIn: 'root' })
export class EmailService {
  constructor(private readonly api: ApiService) {}

  sendEmail(payload: SendEmailPayload) {
    return this.api.post<ApiEnvelope<SendEmailResult>>('email/send', payload).pipe(map((r) => r.data));
  }
}
